<script>
import Vue from 'vue'
import {mapActions} from "vuex";

export default Vue.extend({
  name: "enquiryTable",
  data() {
    return {
      totalConciergeEnquiries: 0,
      pageConciergeEnquiries: 1,
      sizeConciergeEnquiries: 25,
      conciergeEnquiries: [],
      agentNotes: {},
      registerBuyerNotesHistory:{}
    }
  },
  methods: {
    ...mapActions("enquiry", ["getConciergeEnquiries", "getBuyerRegistrationAgentNotes", "createBuyerRegistrationAgentNoteRecord"]),
    retrieveConciergeEnquiryList() {
      let params = {
        page: this.pageConciergeEnquiries,
        size: this.sizeConciergeEnquiries,
      }
      this.getConciergeEnquiries({params: params, callback: this.callback})
    },
    truncateQuestion(value) {
      if (value && value.length > 25) {
        return value.substring(0, 25) + '...';
      }
      return value;
    },
    getFullName(value) {
      return value.firstName + ' ' + value.lastName
    },
    getFullAddress(value) {
      return value.firstName + ' ' + value.lastName
    },
    showPropertyDetail(key, val) {
      if (key == 1) {
        this.$router.push({path: '/uconnect/view', query: {pid: val.propertyId}})
      }
    },
    handleCurrentChange(val) {
      this.pageConciergeEnquiries = val
      this.getConciergeEnquiries()
    },
    onExpandChange(row, expandedRows) {
      if (row.contactId && expandedRows.some(r => r.contactId === row.contactId)) {
        this.fetchBuyerRegisterAgentNotesForContact(row.contactId);
      }
    },
    fetchBuyerRegisterAgentNotesForContact(contactId) {
      let params = {
        contactId: contactId,
      }
      this.getBuyerRegistrationAgentNotes({params: params, callback: this.callback})
    },
    callback(resp, status) {
      switch (status) {
        case 'getConciergeEnquiriesCallback':
          if (resp.code === 0) {
            this.totalConciergeEnquiries = resp.data.totalRecord
            this.conciergeEnquiries = resp.data.list
          } else {
            Utils.alert('', resp.message, 'error')
          }
          break;
        case 'createBuyerRegistrationAgentNoteRecordCallback':
          if (resp.code === 0) {
            this.$message.success('Note added successfully');
            const contactId = resp.data;
            if (contactId && this.agentNotes[contactId]) {
              this.$set(this.agentNotes, contactId, '');
            }
            if (contactId) {
              this.fetchBuyerRegisterAgentNotesForContact(contactId);
            }
          } else {
            Utils.alert('', resp.message, 'error')
          }
          break;
        case 'getBuyerRegistrationAgentNotesCallback':
          if (resp.code === 0) {
            const allNotesList = Array.isArray(resp.data) ? resp.data : [];
            const notesByContact = {};
            allNotesList.forEach(note => {
              const cId = note.contactId;
              if (cId) {
                if (!notesByContact[cId]) {
                  notesByContact[cId] = [];
                }
                notesByContact[cId].push(note);
              }
            });
            Object.keys(notesByContact).forEach(contactId => {
              this.$set(this.registerBuyerNotesHistory, String(contactId), notesByContact[contactId]);
              this.$set(this.registerBuyerNotesHistory, Number(contactId), notesByContact[contactId]);
            });
          } else {
            Utils.alert('', resp.message, 'error')
          }
          break;
        default:
          break;
      }
    },
    addNote(contactId) {
      const note = this.agentNotes[contactId];
      if (!note || !note.trim()) {
        this.$message.error('Please enter agent note');
        return false;
      }

      let params = {
        contactId: contactId,
        note: note,
      }
      this.createBuyerRegistrationAgentNoteRecord({params: params, callback: this.callback})
    },
    rowStyle({row, rowIndex}) {
      if (rowIndex === 0) {
        return {
          backgroundColor: '#d4edda'
        }
      }
      return {}
    },
  },
  mounted() {
    this.retrieveConciergeEnquiryList()
  },
})
</script>

<template>
  <div>
    <el-table
      :data="conciergeEnquiries"
      style="width: 100%;"
      @expand-change="onExpandChange">
      <el-table-column type="expand">
        <template v-slot="scope">
          <div style="padding: 10px; background-color: #f3eeee;">
            <!-- First Row: Agent Notes -->
            <el-row :gutter="10" type="flex">
              <el-col :span="8">
                <div class="info-item">
                  <div class="info-label">
                    <i class="el-icon-notebook-2"></i> Agent Notes
                  </div>
                  <el-form
                    label-position="top"
                    label-width="100px"
                    @submit.native.prevent
                    style="font-family: DINosaur-a, sans-serif;">
                    <el-row :gutter="10">
                      <el-col :span="24">
                        <el-form-item label="Agent Note">
                          <el-input type="textarea" rows="3" placeholder="Agent notes" v-model="agentNotes[scope.row.contactId]" maxlength="100" show-word-limit></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="24">
                        <el-button class="add-note-btn" icon="el-icon-plus" @click="addNote(scope.row.contactId)">Add Note</el-button>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </el-col>
              <el-col :span="16">
                <div class="info-item">
                  <div class="info-label">Agent Note History</div>
                  <div class="info-content" style="display: block; width: 100%;">
                    <el-table
                      v-if="Array.isArray(registerBuyerNotesHistory[scope.row.contactId]) && registerBuyerNotesHistory[scope.row.contactId].length > 0"
                      class="compact-table"
                      :data="registerBuyerNotesHistory[scope.row.contactId]"
                      height="200"
                      :row-style="rowStyle"
                      style="width: 100%">
                      <el-table-column
                        prop="created"
                        label="Date"
                        width="180">
                      </el-table-column>
                      <el-table-column
                        label="Channel Partner"
                        width="180">
                        <template v-slot="innerScope">
                          <span>{{ innerScope.row.cpFirstName + ' ' + innerScope.row.cpLastName }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="note"
                        label="Note">
                      </el-table-column>
                    </el-table>
                    <div v-else style="padding: 10px; text-align: center;">
                      <span class="empty-text">No notes available</span>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="firstName"
        min-width="150"
        label="Name">
        <template v-slot="scope">
          <span>{{ getFullName(scope.row) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="email"
        min-width="200"
        label="Email">
      </el-table-column>
      <el-table-column
        prop="phoneNumber"
        min-width="250"
        label="Phone Number">
      </el-table-column>
      <el-table-column
        prop="propertyAddress"
        min-width="150"
        label="Property Address">
        <template v-slot="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.propertyAddress" placement="right">
            <span>{{ truncateQuestion(scope.row.propertyAddress) }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="nominatedClientName"
        min-width="150"
        label="Nominated Client Name">
      </el-table-column>
      <el-table-column
        prop="question"
        min-width="200"
        label="Question">
        <template v-slot="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.question" placement="right">
            <span>{{ truncateQuestion(scope.row.question) }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="created"
        min-width="200"
        label="Date">
        <template v-slot="scope">
          <span>{{ scope.row.created }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="propertyId"
        min-width="200"
        label="Actions">
        <template v-slot="scope">
          <el-button class="btn-link" @click="showPropertyDetail(1,scope.row)" type="text" icon="el-icon-view">View
            Property
          </el-button>
<!--          <span class="divider"> | </span>-->
<!--          <el-button class="btn-link" @click="handleDelete(scope.row)" type="text" icon="el-icon-delete">Remove-->
<!--          </el-button>-->
        </template>
      </el-table-column>
    </el-table>
    <div class="fen" v-if="totalConciergeEnquiries">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="pageConciergeEnquiries"
        :page-size="25"
        layout="total, prev, pager, next"
        :total="totalConciergeEnquiries">
      </el-pagination>
    </div>
  </div>
</template>

<style scoped lang="scss">
.btn-link {
  color: rgba(0, 51, 51, 0.9);
  font-family: 'DINosaur-a', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  text-decoration-line: underline;
}
.add-note-btn {
  font: 500 12px DINosaur-a, sans-serif;
  border: 3px solid #003333;
  color: #ffffff;
  background-color: #003333;
  padding: 10px 0;
  cursor: pointer;
  width: 100%;
}
.btn-link:hover {
  color: #003333;
}
</style>



// WEBPACK FOOTER //
// src/components/enquiry/enquiryTable.vue